module.exports = __webpack_public_path__ + "static/media/ic_expand_arrow.0f9e50d0.svg";